import { render, staticRenderFns } from "./CandidateDisclaimer.vue?vue&type=template&id=5e8c0d4d&scoped=true&"
import script from "./CandidateDisclaimer.vue?vue&type=script&lang=ts&"
export * from "./CandidateDisclaimer.vue?vue&type=script&lang=ts&"
import style0 from "./CandidateDisclaimer.vue?vue&type=style&index=0&id=5e8c0d4d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8c0d4d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
